module.exports = __webpack_public_path__ + "static/media/FiraCode-Medium.199a7bd6.ttf";